export const BtnPermissions = {
  NganhHang: {
    LIST: 'management#nganhhang_list_by_store',
    DETAIL: 'management#nganhhang_detail_by_id',
    ADD_OR_UPDATE: 'management#nganhhang_update_by_id'
  },
  NhaCungCap: {
    LIST: 'management#nhacc_list_by_store',
    DETAIL: 'management#nhacc_detail_by_id',
    ADD_OR_UPDATE: 'management#nhacc_update_by_id',
    REMOVE: 'management#nhacc_remove_by_id'
  },
  SanPham: {
    LIST: 'management#products_list_by_store',
    DETAIL: 'management#products_detail_by_id',
    ADD_OR_UPDATE: 'management#products_update_by_id'
  },
  Kho: {
    LIST: 'management#kho_list_by_store',
    DETAIL: 'management#kho_detail_by_id',
    ADD_OR_UPDATE: 'management#kho_update_by_id'
  },
  ChuongTrinh: {
    LIST: 'chuongtrinh#chuongtrinh_list_by_store',
    DETAIL: 'chuongtrinh#chuongtrinh_detail_by_id',
    ADD_OR_UPDATE: 'chuongtrinh#chuongtrinh_update_by_id',
    LIST_PRODUCT: 'chuongtrinh#chuongtrinh_product_list_by',
    UPDATE_PRODUCT: 'chuongtrinh#chuongtrinh_update_product'
  },
  NguoiDungKho: {
    ADD_OR_UPDATE: 'management#nguoidung_kho_update_by_id',
  },
  Role: {
    LIST: 'management#kho_list_by_store',
    DETAIL: 'management#kho_detail_by_id',
    ADD_OR_UPDATE: 'management#kho_update_by_id'
  },
  NguoiDungRole: {
    ADD_OR_UPDATE: 'role#nguoidung_role_update_by_id',
  },
  KhachHangNhom: {
    ADD_OR_UPDATE: 'role#nguoidung_role_update_by_id',
  },
  PermissionRole: {
    ADD_OR_UPDATE: 'permissionrole#permission_role_update_by_id'
  },
  GiaoHang: {
    ADD_OR_UPDATE: 'giaohang#giaohang_update',
    CONFIRM_RECEIVED_MONEY: 'giaohang#giaohang_confirm_received_money',
  },
  KhachHang: {
    LIST: 'khachhang#khachhang_list_by_store',
    DETAIL: 'khachhang#khachhang_detail_by_id',
    ADD_OR_UPDATE: 'khachhang#khachhang_update_by_id',
    UPDATE_DIEM_TICH_LUY: 'khachhang#khachhang_update_diem_tich_luy',
    REMOVE: 'khachhang#khachhang_remove_by_id',
    UPLOAD_EXCEL: 'khachhang#khachhang_upload',
    UPLOAD_DIEM_EXCEL: 'khachhang#khachhang_upload_diem_tich_luy',
    EXPORT_EXCEL: 'khachhang#khachhang_export_by_store',
    ADD_USERS: 'khachhang#khachhang_user_update',
  },
  NhapHang: {
    ADD: 'import#save_nhapkho',
    EDIT: 'import#update_nhap',
    APPROVE: 'import#duyet_nhap',
    CANCEL: 'import#huy_duyet'
  },
  DonHang: {
    // them/ sua don hang
    SAVE_ORDER: 'export#save_order',
    // huy don hang
    CANCEL_ORDER: 'export#cancel_order',
    // xoa don hang
    DELETE_ORDER: 'export#delete_order',
    // tiep nhan xu ly don hang
    PROCESS_ORDER: 'export#process_order',
    // duyet hoan thanh don hang
    APPROVE_ORDER: 'export#approve_order',
    // tra lai hang ve kho
    RETURN_ORDER_ITEMS: 'export#return_order',
    // tra lai don hang
    REVERT_ORDER: 'export#revert_order',
    // xem danh sach don hang/ tim kiem don hang
    LIST_ORDER: 'export#danhSachDonHang',
    // xuat danh sach don ra excel
    EXPORT_ORDERS_EXCEL: 'export#orders_export_by_store'
  },
  Setting: {
    ADD_OR_UPDATE: 'management#update_setting_by_store'
  },
  BacLuong: {
    LIST: 'bacluong#bacluong_list_by_store',
    DETAIL: 'bacluong#bacluong_detail_by_id',
    ADD_OR_UPDATE: 'bacluong#bacluong_update_by_id',
    ADD_USERS: 'bacluong#bacluong_update_by_id',
  },
  NhomKhachHang: {
    LIST: 'nhomkhachhang#nhomkhachhang_list_by_store',
    DETAIL: 'nhomkhachhang#nhomkhachhang_detail_by_id',
    ADD_OR_UPDATE: 'nhomkhachhang#nhomkhachhang_update_by_id',
    REMOVE: 'nhomkhachhang#nhomkhachhang_remove_by_id'
  },
  LichSuThanhToan: {
    REMOVE: 'congno#lichsuthanhtoan_remove_by_id'
  },
  CongNoKhachHang: {
    THANHTOAN: 'congno#congno_kh_thanh_toan_no',
    NHAPDAUKY: 'congno#congno_kh_update_dau_ky'
  },
  Checkin: {
    ADD_OR_UPDATE: 'users#checkin_update_by_user',
  },
  TraThuongDiem: {
    TRATHUONG: 'khachhang#khachhang_trathuong',
    REMOVE: 'khachhang#lichsutrathuong_remove_by_id'
  },
}

export const BtnType = {
  Button: 1,
  ButtonLink: 2,
  Checkbox: 3
}


// WEBPACK FOOTER //
// ./src/lib/BtnPermissions.js